import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=489ac0ca&scoped=true&"
import script from "./VideoElement.vue?vue&type=script&lang=js&"
export * from "./VideoElement.vue?vue&type=script&lang=js&"
import style0 from "./VideoElement.vue?vue&type=style&index=0&id=489ac0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ac0ca",
  null
  
)

export default component.exports